<template>
    <div class="pa-5 compact-form">
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Client name" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeClient.name"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    @input="updateField($event, 'name')"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Chain name" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeClient.chain_name"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    @input="updateField($event, 'chain_name')"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Shop name" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeClient.shop_name"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    @input="updateField($event, 'shop_name')"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Country" | t }}</v-col>
            <v-col cols="6">
                <v-autocomplete
                    v-model="country"
                    :items="countries"
                    :loading="isLoading"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    hide-no-data
                    hide-selected
                    :item-text="
                        item =>
                            (item.name_et ? item.name_et : null) +
                            (item.name_en ? item.name_en : null) +
                            ' (' +
                            item.code +
                            ')'
                    "
                    item-value="code"
                    outlined
                    :placeholder="t('Start typing to Search')"
                    return-object
                >
                    <template slot="selection" slot-scope="{ item, selected }">
                        {{ item.name_et ? item.name_et : item.name_en }} ({{ item.code }})
                    </template>
                    <template slot="item" slot-scope="{ item, tile }">
                        <country-flag :country="item.code" size="small" class="mr-1" />
                        {{ item.name_et ? item.name_et : item.name_en }} ({{ item.code }})
                    </template>
                </v-autocomplete>
            </v-col>
            <v-col :cols="1">
                <country-flag v-if="country && country.code" :country="country.code" class="mt-0 ml-1" size="normal" />
            </v-col>
        </v-row>

        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Address" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeClient.address"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    @input="updateField($event, 'address')"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Latitude" | t }}/{{ "Longitude" | t }}</v-col>
            <v-col cols="3">
                <v-text-field
                    :value="activeClient.latitude"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    type="number"
                    @input="updateField($event, 'latitude')"
                />
            </v-col>
            <v-col cols="3">
                <v-text-field
                    :value="activeClient.longitude"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    type="number"
                    @input="updateField($event, 'longitude')"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import Store from "@/store";
import { mapState, mapActions } from "vuex";
import moment from "moment";
import CountryFlag from "vue-country-flag";

export default {
    name: "client-info-edit-tab",
    components: {
        DatePicker,
        CountryFlag
    },
    data() {
        return {
            metDate: "",
            isLoading: false,
            country: null
        };
    },

    async mounted() {
        setTimeout(async () => {
            if (this.users.length <= 0) {
                await this.getFrequentlyUsedQueries({ users: true });
            }
            await Store.dispatch("fetchCountries");
            if (this.activeClient.country_code) {
                this.country = this.countries.find(x => x.code === this.activeClient.country_code);
            }
        }, 200);
    },
    watch: {
        country: function(value) {
            value && value.code ? this.updateField(value.code, "country") : this.updateField(null, "country");
        }
    },
    methods: {
        ...mapActions(["getFrequentlyUsedQueries"]),
        updateField(value, field) {
            Store.commit("ClientStore/updateActiveClientProperty", { prop: field, value: value });
        }
    },
    computed: {
        ...mapState(["countries", "users"]),
        ...mapState("ClientStore", ["activeClient", "metPlaces"])
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}
</style>
